import { faChevronRight, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface Props {
    sendingLink: boolean
    handleSendMagicLink: () => void
}

export default function EmailLinkButton({
    sendingLink,
    handleSendMagicLink,
}: Props): React.JSX.Element {
    return (
        <button
            type="button"
            disabled={sendingLink}
            onClick={handleSendMagicLink}
            className={`w-full rounded-lg border border-gray-200 bg-blue-500 text-white hover:bg-blue-600 p-4 text-left shadow-sm transition focus:outline-none focus:ring-2 focus:ring-ctxt-blue focus:ring-offset-2 ${
                sendingLink
                    ? 'cursor-not-allowed opacity-60'
                    : 'hover:border-ctxt-blue'
            } flex items-center gap-4`}
        >
            <FontAwesomeIcon icon={faEnvelope} className="text-xl" />
            <div className="flex-1 text-left">
                <p className="font-semibold leading-tight">Email me a link</p>
                <p className="text-sm leading-snug text-white/85">
                    No password required! 🚀
                </p>
            </div>
            <FontAwesomeIcon icon={faChevronRight} className="" />
        </button>
    )
}
